import { render, staticRenderFns } from "./YijingDialog.vue?vue&type=template&id=0a53cf7b&scoped=true&"
import script from "./YijingDialog.vue?vue&type=script&lang=js&"
export * from "./YijingDialog.vue?vue&type=script&lang=js&"
import style0 from "./YijingDialog.vue?vue&type=style&index=0&id=0a53cf7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a53cf7b",
  null
  
)

export default component.exports